import request from "@/utils/request";
//挂账信息
export function ontickInfo() {
  return request({
    url: `/mall/receive-pay/list/ontick-info`,
    method: "get"
  });
}
//对账单列表 https://gitlab.threesoft.cn/sirui/erp-partners/blob/qa/docs/apis/mall/receive-pay/list/GET_statement.md
export function statementList(params) {
  return request({
    url: `/mall/receive-pay/list/statement`,
    method: "get",
    params
  });
}
//往来单据列表 https://gitlab.threesoft.cn/sirui/erp-partners/blob/qa/docs/apis/mall/receive-pay/list/GET.md
export function receivePayList(params) {
  return request({
    url: "/mall/receive-pay/list",
    method: "get",
    params
  });
}
//往来单据明细列表 https://gitlab.threesoft.cn/sirui/erp-partners/blob/qa/docs/apis/mall/receive-pay/list/GET_sub.md
export function receivePayDetailsList(params) {
  return request({
    url: "/mall/receive-pay/list/sub",
    method: "get",
    params
  });
}
//支付明细列表 https://gitlab.threesoft.cn/sirui/erp-partners/blob/qa/docs/apis/mall/receive-pay/list/GET_settle.md
export function settleList(data) {
  return request({
    url: "/mall/receive-pay/list/settle",
    method: "post",
    data
  });
}
//对账单明细
export function statementDetails(id) {
  return request({
    url: "/mall/receive-pay/list/statement-sub",
    method: "get",
    params: { id }
  });
}
//对账单票据列表 https://gitlab.threesoft.cn/sirui/erp-partners/blob/qa/docs/apis/mall/receive-pay/list/GET_statement-bills.md
export function statementDetailsGoods(params) {
  return request({
    url: "/mall/receive-pay/list/statement-bills",
    method: "get",
    params
  });
}
//预付列表
export function preFundOutList(data) {
  return request({
    url: "/mall/receive-pay/list/prev-fund-out-list",
    method: "post",
    data
  });
}
//预付冲销列表
export function prevFundOutLogs(data) {
  return request({
    url: "/mall/receive-pay/list/prev-fund-out-logs",
    method: "post",
    data
  });
}
//预收列表
export function preFundInList(data) {
  return request({
    url: "/mall/receive-pay/list/prev-fund-in-list",
    method: "post",
    data
  });
}
//预收冲销明细列表
export function prevFundInLogs(data) {
  return request({
    url: "/mall/receive-pay/list/prev-fund-in-logs",
    method: "post",
    data
  });
}
//支付方式列表
export function payMethods() {
  return request({
    url: "/mall/receive-pay/list/pay-list",
    method: "get"
  });
}
//支付
export function postPay(params) {
  return request({
    url: `/mall/receive-pay/pay`,
    method: "post",
    data: params
  });
}
//单据类型列表
export function billTypes() {
  return request({
    url: "/mall/receive-pay/bill-types",
    method: "get"
  });
}
